<template>
  <div>
    <el-form label-position="right" label-width="100px" style="margin: 0 80px 0 80px">
      <div style="display: flex">
        <div style="flex-grow: 1">
          <el-form-item label="工单号">
            <label class="value">{{work.extraId || work.id}}</label>
          </el-form-item>
          <el-form-item label="车牌号">
            <label class="value">{{work.carNo | carNo}}</label>
          </el-form-item>
          <el-form-item label-width="100px" label="预计完成时间">
            <label class="value">{{work.enterTime}}</label>
          </el-form-item>
        </div>
        <div style="flex-grow: 1">
          <el-form-item label="服务顾问">
            <label class="value">{{work.consultantName}}</label>
          </el-form-item>
          <el-form-item label="品牌/车系" prop="brandModel">
            <label class="value">{{work.brandName}} / {{work.model}}</label>
          </el-form-item>
          <el-form-item label-width="100px" label="预计交车时间" prop="estimateDeliveryTime">
            <label class="value">{{work.estimateDeliveryTime}}</label>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div style="display: flex; height: 240px; padding: 0 30px 20px" v-loading="loading">
      <div v-show="pattern === 'CONFIRM'" style="width: 160px; flex-grow: 0" class="border">
        <div style="width: 100%; height: 30px; line-height: 30px; background-color: #dfdfe2; text-align: center">
          工序选择
        </div>
        <div style="display: flex; flex-direction: column; margin: 10px auto auto 30px">
          <el-checkbox v-for="procedure of procedures" :key="procedure.id" v-model="procedure.enable"
                       @change="changeProcedureSelection" size="big">
            {{procedure.name}}
          </el-checkbox>
        </div>
      </div>
      <div style="flex-grow: 1; overflow-y: auto;" class="border border-right">
        <transition-group name="list-complete-x">
          <div v-for="procedure of activeWorkProcedures" :key="procedure.id"
               style="display: inline-block;margin: 10px; width: 130px; border: 1px solid #8cc8ff; cursor: pointer; border-radius: 4px"
               class="list-complete-item"
               @click="clickProcedure(procedure)">
            <div
              style="height: 24px; line-height: 24px; text-align: center; border-bottom: 2px solid #dfdfe2; color: #1879ff; font-weight: bold">
              {{procedure.name}}
            </div>
            <div style="display: flex; margin: 6px">
              <div>
                <div class="card-item" v-if="procedure.technicianName">技师</div>
                <div class="card-item" v-else-if="procedure.dispatch2Team">工组</div>
                <div class="card-item" v-else>技师</div>
                <div class="card-item">开始</div>
                <div class="card-item">维修</div>
                <div class="card-item">结束</div>
              </div>
              <div style="margin-top: -1px">
                <!-- 优先显示技师名称 -->
                <div v-if="procedure.technicianName" class="value card-item">{{procedure.technicianName}}</div>
                <div v-else-if="procedure.dispatch2Team" class="value card-item">{{procedure.teamName || '暂无'}}</div>
                <div v-else class="value card-item">暂无</div>
                <div class="value card-item">{{procedure.startTime}}</div>
                <div class="value card-item">{{procedure.repairHours}}</div>
                <div class="value card-item">{{procedure.endTime}}</div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <select-technician-dialog :visible.sync="dialog.showSelectTechnician"
                              :procedure="dialog.procedure"
                              @selectTeam="onSelectTeam"
                              @selectTechnician="onSelectTechnician">
    </select-technician-dialog>
  </div>
</template>

<script>
  import SelectTechnicianDialog from '@/views/kanban/dialog/confirm-work/SelectTechnicianDialog'
  import { calWorkPlan } from '@/utils/request'

  export default {
    name: 'DispatchPanel',
    components: { SelectTechnicianDialog },
    props: {
      work: {
        type: Object,
        required: true
      },
      dispatchList: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        required: true
      },
      pattern: { // 'CONFIRM', 'DISPATCH'
        type: String,
        required: true
      }
    },
    data () {
      return {
        dialog: {
          procedure: {},
          selectTeam: false,
          showSelectTechnician: false
        }
      }
    },
    methods: {
      clickProcedure (procedure) {
        debugger
        console.log(procedure)
        if (this.dispatchPattern === 'AUTO' || this.dispatchPattern === 'GRAB') {
          const alertInfo = this.dispatchPattern === 'AUTO' ? '处于自动派工模式' : '处于抢单模式'
          this.$alert(alertInfo + '，不能手动派工！', {
            confirmButtonText: '确定'
          }).catch(() => {
          })
        } else if (procedure.beenWorked && !procedure.technicianInvalid) {
          this.$alert(`该工序曾经被【${procedure.technicianName}】做过，不能改派！`, {
            confirmButtonText: '确定'
          }).catch(() => {
          })
        } else {
          this.dialog.procedure = procedure
          this.dialog.showSelectTechnician = true
        }
      },
      onSelectTeam (team) {
        this.dialog.procedure.teamId = team.id
        this.dialog.procedure.teamName = team.name
        calWorkPlan(this.dispatchList).then(response => {
          Object.assign(this.dispatchList, response.data)
        })
      },
      onSelectTechnician (technician) {
        this.dialog.procedure.technicianId = technician.id
        this.dialog.procedure.technicianName = technician.name
        // 如果设置钣金工序，则同时设置装件技师为同一个技师
        if (this.dialog.procedure.type === 'SHEET_METAL') {
          for (const procedure of this.dispatchList.procedures) {
            if (procedure.type === 'ASSEMBLY') {
              procedure.technicianId = technician.id
              procedure.technicianName = technician.name
              break
            }
          }
        }
        calWorkPlan(this.dispatchList).then(response => {
          Object.assign(this.dispatchList, response.data)
        })
      },
      changeProcedureSelection () {
        // 改变了工单的工序集合，重新计算工作计划
        calWorkPlan(this.dispatchList).then(response => {
          Object.assign(this.dispatchList, response.data)
        })
      }
    },
    computed: {
      procedures () {
        return this.dispatchList.procedures || []
      },
      activeWorkProcedures () {
        return this.procedures.filter(procedure => procedure.enable)
      },
      dispatchPattern () {
        return this.$store.state.user.workshop.dispatchPattern
      }
    }
  }
</script>

<style lang="scss" scoped>
  .border {
    border-left: 2px solid #dfdfe2;
    border-top: 2px solid #dfdfe2;
    border-bottom: 2px solid #dfdfe2;
  }

  .border-right {
    border-right: 2px solid #dfdfe2;
  }

  .card-item {
    height: 24px;
    line-height: 24px;
  }

  .value {
    font-size: 13px;
  }
</style>
